<template>
<div>
  <section class="content-header">
    <h1>
      时间排行
      <small>学习综合项排行榜</small>
    </h1>
    <ol class="breadcrumb">
      <li><a href="#/"><i class="fa fa-dashboard"></i> Home</a></li>
      <li><a href="#/loudSpeakLearn/learnTime">学习综合项排行榜</a></li>
      <li class="active">时间排行</li>
    </ol>
  </section>

  <section class="content">
    <el-card class="box-card" body-style="padding-bottom:0px">
      <el-form :inline="true" :model="filters">
				<el-form-item>
          <el-select v-model="filters.customers" multiple filterable clearable placeholder="客户名称" style="width: 360px">
            <el-option
              v-for="item in customers"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
        <el-form-item>
          <el-date-picker v-model="filters.dateRange" type="daterange" start-placeholder="开始日期"
            end-placeholder="结束日期" :picker-options="pickerOptions" :default-value="currentDate" value-format="yyyy-MM-dd">
          </el-date-picker>
				</el-form-item>
        <el-form-item v-show="$auth.check('ROLE_QOOCO')">
          <el-select v-model="filters.orgType" filterable clearable placeholder="机构类型">
            <el-option
              v-for="item in orgTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="query">查询</el-button>
				</el-form-item>
			</el-form>
      <div class="duration">
        <span class="label">当前查询时间段：</span>
        <span class="value">{{dateRange[0]}} 至 {{dateRange[1]}}</span>
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">合作校平均学习时长排行榜</span>
      </div>
      <el-tabs v-model="durationTabActive" type="card">
        <el-tab-pane label="平均时长" name="avg">
          <div class="echart">
            <IEcharts :option="timeRanking" :resizable="true" :loading="loading"></IEcharts>
          </div>
        </el-tab-pane>
        <el-tab-pane label="总时长" name="total">
          <el-button id="exportBtn" type="primary" icon="el-icon-download" @click="exportAllOrgDurs">导出全部</el-button>
          <div class="echart">
            <IEcharts :option="totaltimeRanking" :resizable="true" :loading="loading"></IEcharts>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">合作校平均学习时长分布</span>
      </div>
      <div class="echart">
        <IEcharts :option="timeSpread" :resizable="true" :loading="loading"></IEcharts>
      </div>
    </el-card>
  </section>
</div>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full'
import {mapGetters} from 'vuex'
import {loadLearnTimeData} from 'api/loud-speak-learn'
import {subLabel, getLastWeek, withRank, extractArrsFromObj} from 'common/js/app-utils'
import {baseUrl} from 'api/base'
import $ from 'jquery'
// import {Loading} from 'element-ui'

export default {
  computed: {
    ...mapGetters([
      'customers',
      'pickerOptions',
      'orgTypes'
    ])
  },
  data () {
    return {
      durationTabActive: 'avg',
      dateRange: [],
      currentDate: new Date(),
      filters: {
        customers: [],
        dateRange: [],
        orgType: ''
      },

      loading: true,
      timeRanking: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {x: '25%', y: '14%', width: '70%', height: '75%'},
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -12,
            formatter: subLabel
          }
        },
        series: [{
          name: '平均时长（分钟）',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },
      totaltimeRanking: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {x: '25%', y: '14%', width: '70%', height: '75%'},
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -12,
            formatter: subLabel
          }
        },
        series: [{
          name: '总时长（分钟）',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },

      timeSpread: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {x: '15%', y: '14%', width: '70%', height: '75%'},
        xAxis: {
          data: []
        },
        yAxis: {},
        series: [{
          name: '学校（数目）',
          type: 'bar',
          data: [0, 0, 0, 0]
        }],
        color: ['rgb(91,155,213)']
      }
    }
  },
  components: {
    IEcharts
  },
  mounted () {
    this.query()
  },
  methods: {
    exportAllOrgDurs () {
      let form = $('<form>')
      form.attr('style', 'display:none')
      form.attr('target', '')
      form.attr('method', 'post')
      form.attr('action', baseUrl + 'exports/exportAllOrgDurs')
      let input1 = $('<input>')
      let input2 = $('<input>')
      input1.attr('type', 'hidden')
      input1.attr('name', 'conditionStr')
      input1.attr('value', JSON.stringify(this.filters))
      input2.attr('type', 'hidden')
      input2.attr('name', 'token')
      input2.attr('value', localStorage.getItem('default_auth_token'))
      $('body').append(form)
      form.append(input1)
      form.append(input2)
      form.submit()
    },
    query () {
      this._showDateRange()
      this._loadLearnTimeData(this.filters)
    },
    _showDateRange () {
      let t = this.filters.dateRange
      if (t && t.length === 2) {
        this.dateRange = t
      } else {
        this.dateRange = getLastWeek()
      }
    },
    _loadLearnTimeData () {
      this.loading = true
      loadLearnTimeData(this.filters)
      .then((res) => {
        this.loading = false
        this.timeRanking.yAxis.data = withRank(res.duration_ranking.keys.reverse(), res.duration_ranking.ranks.reverse())
        this.timeRanking.series[0].data = res.duration_ranking.values.reverse()
        this.timeSpread.xAxis.data = res.duration_spread.keys
        this.timeSpread.series[0].data = res.duration_spread.values

        let arrs = extractArrsFromObj(res.total_duration_ranking, ['name', 'value', 'ranking'])
        this.totaltimeRanking.yAxis.data = withRank(arrs.name, arrs.ranking)
        this.totaltimeRanking.series[0].data = arrs.value
      }, (msg) => {
        this.loading = false
        this._resetData()
        this.$message.error(msg)
      })
    },
    _resetData () {
      this.timeRanking.yAxis.data = []
      this.timeRanking.series[0].data = []
      this.totaltimeRanking.yAxis.data = []
      this.totaltimeRanking.series[0].data = []
      this.timeSpread.xAxis.data = []
      this.timeSpread.series[0].data = []
    }
  }
}
</script>


<style lang="stylus" scoped>
  @import '~common/stylus/base'
</style>



// WEBPACK FOOTER //
// src/components/loud-speak-learn/learn-time.vue